module.exports = __webpack_public_path__ + "img/disc.45831f91.jpeg";